import { createErrorFromEvent } from '../utils';
let previousErrorHandler = null;
let previousRejectionHandler = null;
export const browserErrorEmitterPlugin = (windowInstance) => {
    return (reporter) => ({
        start() {
            previousErrorHandler = windowInstance.onerror;
            previousRejectionHandler = windowInstance.onunhandledrejection;
            windowInstance.onerror = (event, source, lineNumber, columnNumber, uncaughtError) => {
                const error = uncaughtError instanceof Error ? uncaughtError : createErrorFromEvent(event);
                reporter.addError(error, {});
                if (typeof previousErrorHandler === 'function') {
                    previousErrorHandler.call(windowInstance, event, source, lineNumber, columnNumber, uncaughtError);
                }
            };
            windowInstance.onunhandledrejection = (event) => {
                const error = new Error(event.reason);
                reporter.addError(error, {});
                if (typeof previousRejectionHandler === 'function') {
                    previousRejectionHandler.call(windowInstance, event);
                }
            };
        },
        stop() {
            windowInstance.onunhandledrejection = previousRejectionHandler;
            windowInstance.onerror = previousErrorHandler;
        },
    });
};
//# sourceMappingURL=index.js.map